import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { ArchiveDNSResultsService } from 'src/app/services/archive-dns-results.service';
import { DecisionTransportService } from 'src/app/services/decision-transport.service';
import { InstructionService } from 'src/app/services/instruction.service';
import { LoadStimuliService } from 'src/app/services/load-stimuli.service';
import { StudyNavigationService } from 'src/app/services/study-navigation.service';
//import { LoadConfigBackendService } from '../../services/load-config-backend.service';
//import { UtilsService } from '../../services/utils.service';
//import { LoadConfigService } from '../../services/load-config.service';

import { fadeInLeftAnimation } from 'angular-animations';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  trigger,
  state,
  style,
  transition,
  animate,
} from '@angular/animations';

@Component({
  selector: 'app-conjoint-display',
  templateUrl: './conjoint-display.component.html',
  styleUrls: ['./conjoint-display.component.scss'],
  animations: [fadeInLeftAnimation()],
})
export class ConjointDisplayComponent implements OnInit, OnDestroy {
  showIntermission: boolean = false;

  //image_base: string = 'data:image/JPEG;base64,';
  //image_base: string = 'data:image/PNG;base64,';
  //image_1: string;
  //image_2: string;

  stimuli: any[];

  // information about block:
  blockName: string;
  blockNr: number;
  practiceMode: boolean = false;
  readingMode: boolean = false;

  // sets the type between default, brand and agreement
  type: string = 'conjoint';
  mode: string = 'IAT';

  // used to iterate through comparisons
  id: number = 0;
  finishedTrial: boolean = false;

  // flag for automatically proceeding to next item in needs array
  dontProceed: boolean = false;

  constructor(
    //private loadConfigBackendService: LoadConfigBackendService,
    //private loadConfigService: LoadConfigService,

    private loadStimuli: LoadStimuliService,
    private archiveDNSResultsService: ArchiveDNSResultsService,
    private decisionTransporter: DecisionTransportService,
    private navigationService: StudyNavigationService,
    private instructionService: InstructionService,
    //private utils: UtilsService,
    @Inject('BASE_URL') private baseUrl: string
  ) {}

  animationState: boolean;

  animate() {
    this.animationState = false;
    setTimeout(() => {
      this.animationState = true;
    }, 1);
  }

  ngOnInit(): void {
    // needed to make decision via mouse work
    this.decisionTransporter.decisionEvent.subscribe((decision: number) => {
      this.nextItem(decision);
    });

    //this.init();

    this.getIATConfig();

    this.archiveDNSResultsService.initializeArchivedIATResults({
      mode: this.mode,
      IATtype: this.type,
      blockID: this.blockNr,
    });

    this.setStimuli();
  }

  ngOnDestroy() {}

  /*   private init = async () => {
    await this.loadConfigBackendService.getImages().then((data) => {
      this.image_1 = this.image_base.concat(data['pic_1']);
      this.image_2 = this.image_base.concat(data['pic_2']);
    });
  };
 */
  private setStimuli() {
    this.stimuli = this.loadStimuli.getStimuli(
      this.type,
      this.readingMode,
      this.practiceMode,
      this.mode,
      this.instructionService.getLanguageIdentifier()
    );
  }

  private getIATConfig() {
    const IATConfig = this.navigationService.IATconfig;

    this.practiceMode = IATConfig.practiceMode;
    this.readingMode = IATConfig.readingMode;
    // we need to disable automatic skipping to next word when in reading mode

    this.type = IATConfig.type;
    this.mode = IATConfig.mode;
    this.blockName = IATConfig.blockName;
    this.blockNr = IATConfig.blockNr;

    if (this.mode === 'reading') {
      this.dontProceed = true;
    }

    if (
      (this.mode === 'IAT' || this.mode === 'practice') &&
      IATConfig['proceedAutomatically'] === false
    ) {
      this.dontProceed = true;
    }
  }

  //Event Handler: save user selection and then load next brand comparison

  saveDecisionAndLoadNextItem(
    receivedUserInput: boolean = true,
    decision: string | number
  ) {
    this.archiveDNSResultsService.saveConjointDecision({
      IATtype: this.type,
      mode: this.mode,
      stimulus: this.stimuli[this.id],
      decision,
      receivedUserInput,
    });
    this.nextItem(decision, receivedUserInput);
  }

  // Shows the next item

  nextItem = (decision: number | string, receivedUserInput: boolean = true) => {
    if (this.id < this.stimuli.length) {
      this.id++;

      // trial is finished
      if (this.id === this.stimuli.length) {
        this.finishedTrial = true;

        this.navigationService.renderNext();
      }
    } else {
      // trial is finished
      this.finishedTrial = true;
    }
  };

  getImageFilePath(fileName: string) {
    return `${this.baseUrl}assets/images/${fileName}`;
  }
}
